import type {
  CalendarGridColDef,
  CalendarGridContext,
  CalendarGridSetFilterParams,
  CalendarGridSetFilterValuesFunc,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';

export type Value = string | null | undefined;

export const setFilterValuesFunc: CalendarGridSetFilterValuesFunc = ({ success, context }) => {
  const { withCustomSectors, customSectors, sectors } = context as CalendarGridContext;
  const options = withCustomSectors ? customSectors : sectors;

  success(options.map(sector => sector.label));
};

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data, context }) => {
  const { withCustomSectors } = context as CalendarGridContext;

  if (withCustomSectors) {
    return data?.issuer?.customSectors?.customSector?.name;
  }

  return data?.issuer?.sectorDisplayName;
};

const sectorColDef: CalendarGridColDef<Value> = {
  colId: 'sector',
  headerName: 'Sector',
  width: 131,
  type: 'text',
  valueGetter,
  filter: 'agSetColumnFilter',
  filterParams: {
    values: setFilterValuesFunc,
    refreshValuesOnOpen: true,
  } satisfies CalendarGridSetFilterParams,
};

export default sectorColDef;
